import React from "react";
import c1 from "./Images/c1.png";
import c2 from "./Images/c2.png";
import c3 from "./Images/c3.png";
import c4 from "./Images/c4.png";
import c5 from "./Images/c5.png";
import c6 from "./Images/c6.png";
import c7 from "./Images/card1.png";
import '../App.css';

function Home() {
  const features = [
    {
      title: "Best Deal",
      icon: "info-circle",
      desc: "Dreams Rent Offers a fleet of high-quality",
    },
    {
      title: "Doorstep Delivery",
      icon: "truck",
      desc: "Dreams Rent offers a fleet of high-quality",
    },
    {
      title: "Low Security Deposit",
      icon: "camera",
      desc: "Dreams Rent offers a fleet of high-quality",
    },
    {
      title: "Latest Cars",
      icon: "car",
      desc: "Dreams Rent offers a fleet of high-quality",
    },
    {
      title: "Customer Support",
      icon: "headphones",
      desc: "Dreams Rent offers a fleet of high-quality",
    },
    {
      title: "No Hidden Charges",
      icon: "ban",
      desc: "Dreams Rent offers a fleet of high-quality",
    },
  ];
  return (
    <>
      <div>
        <div class="container mt-5">
          <h2 class="text-center mb-4" style={{ fontSize: "30px" }}>
            <i class="bi bi-star-fill text-warning me-2"></i>Featured Categories{" "}
            <i class="bi bi-star-fill text-warning me-2"></i>
          </h2>
          <div class="row">
            <div class="col-xl-2 col-md-4 col-sm-6 d-flex hov-effect custom-color">
              <div class="card ">
                <h5 className="card-title fw-bold mb-1">Sports Coupe</h5>
                <p className="card-text text-muted mb-2">14 Cars</p>
                <img src={c1} alt="Car 1" className="img-fluid" />
              </div>
            </div>
            <div class="col-xl-2 col-md-4 col-sm-6 d-flex hov-effect custom-color">
              <div class="card">
                <h5 className="card-title fw-bold mb-1">Sedan</h5>
                <p className="card-text text-muted mb-2">12 Cars</p>
                <img src={c2} alt="Car 2" className="img-fluid" />
              </div>
            </div>
            <div class="col-xl-2 col-md-4 col-sm-6 d-flex hov-effect custom-color">
              <div class="card">
                <h5 className="card-title fw-bold mb-1">Sports Car</h5>
                <p className="card-text text-muted mb-2">35 Cars</p>
                <img src={c3} alt="Car 3" className="img-fluid" />
              </div>
            </div>
            <div class="col-xl-2 col-md-4 col-sm-6 d-flex hov-effect custom-color">
              <div class="card">
                <h5 className="card-title fw-bold mb-1">Pick Up</h5>
                <p className="card-text text-muted mb-2">35 Cars</p>
                <img src={c4} alt="Car 4" className="img-fluid" />
              </div>
            </div>
            <div class="col-xl-2 col-md-4 col-sm-6 d-flex hov-effect custom-color">
              <div class="card">
                <h5 className="card-title fw-bold mb-1">Family MVP</h5>
                <p className="card-text text-muted mb-2">35 Cars</p>
                <img src={c5} alt="Car 5" className="img-fluid" />
              </div>
            </div>
            <div class="col-xl-2 col-md-4 col-sm-6 d-flex hov-effect custom-color">
              <div class="card">
                <h5 className="card-title fw-bold mb-1">Crossover</h5>
                <p className="card-text text-muted mb-2">30 Cars</p>
                <img src={c6} alt="Car 6" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <h2 className="mb-3  fw-bold">
          <span role="img" aria-label="spark">
            ✨
          </span>{" "}
          Best Platform for Car Rental{" "}
          <span role="img" aria-label="spark">
            ✨
          </span>
        </h2>
        <p className=" mb-5">
          Why do we choose relax rent bikes generally if we travel in unknown
          cities? With a bike in our hand, we feel which is like a hometown.
        </p>
        <div className="row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0">
            <img src={c7} alt="Car" className="img-fluid " />
          </div>
          <div className="col-md-6">
            <div className="row">
              {features.map((item, index) => (
                <div className="col-sm-6 mb-4" key={index}>
                  <div className="border rounded p-3 shadow-sm h-100 bg-white custom-color">
                    <div className="d-flex align-items-center mb-2">
                      <i
                        className={`bi bi-${item.icon} fs-3 me-3 text-primary`}
                      ></i>
                      <h5 className="mb-0">{item.title}</h5>
                    </div>
                    <p className="text-muted small mb-0"> {item.desc}</p>
                  </div>

                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Home;
